import { ApiClient } from './api'
import type {
  AppSettingListFilters,
  AppSettingListResponse,
  AppSettingResponse,
  CreateAppSettingRequest,
  UpdateAppSettingRequest
} from '../types/appSettings'

export const AppSettingsApi = {
  // List app settings with pagination and filters
  getAppSettings: async (filters: AppSettingListFilters = {}): Promise<AppSettingListResponse> => {
    const params = new URLSearchParams()

    if (filters.page) params.append('page', filters.page.toString())
    if (filters.limit) params.append('limit', filters.limit.toString())
    if (filters.category) params.append('category', filters.category)
    if (filters.setting_type) params.append('setting_type', filters.setting_type)
    if (filters.is_public !== undefined) params.append('is_public', filters.is_public.toString())
    if (filters.is_encrypted !== undefined) params.append('is_encrypted', filters.is_encrypted.toString())
    if (filters.search) params.append('search', filters.search)

    const queryString = params.toString()
    const url = queryString ? `api/app-settings?${queryString}` : 'api/app-settings'

    const response = await ApiClient.get(url)

    return {
      success: response.success,
      data: {
        appSettings: response.data.data || response.data,
        pagination: {
          current_page: response.data.pagination?.page || 1,
          last_page: response.data.pagination?.totalPages || 1,
          per_page: response.data.pagination?.limit || 10,
          total: response.data.pagination?.total || 0
        }
      },
      message: response.message || 'App settings retrieved successfully'
    }
  },

  // Get app setting by key
  getAppSetting: async (key: string): Promise<AppSettingResponse> => {
    return ApiClient.get(`api/app-settings/${key}`)
  },

  // Create new app setting
  createAppSetting: async (data: CreateAppSettingRequest): Promise<AppSettingResponse> => {
    return ApiClient.post('api/app-settings', data)
  },

  // Update app setting by key
  updateAppSetting: async (key: string, data: UpdateAppSettingRequest): Promise<AppSettingResponse> => {
    return ApiClient.put(`api/app-settings/${key}`, data)
  },

  // Delete app setting by key
  deleteAppSetting: async (key: string): Promise<{ success: boolean; message: string }> => {
    return ApiClient.delete(`api/app-settings/${key}`)
  }
}
